import { render, staticRenderFns } from "./IntentionDetail.vue?vue&type=template&id=942903d6&scoped=true&"
import script from "./IntentionDetail.vue?vue&type=script&lang=js&"
export * from "./IntentionDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntentionDetail.vue?vue&type=style&index=0&id=942903d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942903d6",
  null
  
)

export default component.exports